export const QA_NAME_OVERVIEW_COMMUNICATION_SUBJECT =
  'rentalPortalOverviewCommunicationSubject'

export const QA_NAME_OVERVIEW_COMMUNICATION_READ =
  'rentalPortalOverviewCommunicationRead'
